<meta name="viewport" content="width=device-width, initial-scale=1.0">
<main class="d-flex flex-column align-items-center">
    <img alt="AI-Media logo" height="60" id="main-logo" src="../assets/logo.svg" width="128"/>

    <h1 class="text-center welcome">
        <ng-content select="[title]"></ng-content>
    </h1>

    <ng-content ></ng-content>
</main>
